import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";

import { TotalScheduledTime } from "@aika/types";
import { FaThLarge } from "react-icons/fa";
import { MiniWidget } from "./MiniWidget";
import { DateRange, dateRangeValue } from "components/DateRangeControl";
import { format } from "date-fns";

const ScheduledBlocksWidget = ({ range }: { range: DateRange }) => {
  const [data, setData] = useState<TotalScheduledTime>(null!);
  const [loading, setLoading] = useState(true);

  const text = useMemo(() => {
    if (data == null) return "";

    return data.block_count.toLocaleString();
  }, [data]);

  useEffect(() => {
    setLoading(true);
    const dates = dateRangeValue(range);
    const url = `/api/reports/scheduled-time?start=${format(
      dates[0],
      "yyyy-MM-dd"
    )}&end=${format(dates[1], "yyyy-MM-dd")}`;
    axios.get<TotalScheduledTime>(url).then(({ data }) => {
      setData(data);
      setLoading(false);
    });
  }, [range]);

  return (
    <MiniWidget
      text={text}
      loading={loading}
      title="Scheduled Blocks"
      icon={FaThLarge}
    />
  );
};

export default ScheduledBlocksWidget;
